import { render, staticRenderFns } from "./process1.vue?vue&type=template&id=19465387&scoped=true&"
import script from "./process1.vue?vue&type=script&lang=js&"
export * from "./process1.vue?vue&type=script&lang=js&"
import style0 from "./process1.vue?vue&type=style&index=0&id=19465387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19465387",
  null
  
)

export default component.exports